import React, {useEffect, useState, useRef} from 'react';
import {Helmet} from "react-helmet";
import {NonHomeHeader} from "../../components/header/header";
import Footer from "../../components/footer/footer";
import { useParams} from 'react-router-dom';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import Exporting from 'highcharts/modules/exporting';
import FullScreen from 'highcharts/modules/full-screen';
import ExportData from 'highcharts/modules/export-data';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import Accessibility from 'highcharts/modules/accessibility';
import HighchartsMore from 'highcharts/highcharts-more'; // 如果需要使用 Highcharts 的更多功能

import Select from 'react-select'

import './series.css'

import {useUser} from "../../components/auth/UserContext";

// 初始化模块
Exporting(Highcharts);
ExportData(Highcharts);
FullScreen(Highcharts);
OfflineExporting(Highcharts);
Accessibility(Highcharts);
HighchartsMore(Highcharts);

const MySelectComponent = ({addSeries}) => {
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);

    const [selectedOption, setSelectedOption] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const handleChange = selectedOption => {
        setSelectedOption(selectedOption);
    };


    const customLabelFormat = data => (
        <div>
            <span className='option_line1'>{data.title}</span>
            <br/>
            <span className='option_line2'>{data.frequency} , {data.units}</span>
            <br/>
            <span className='option_line3'>{data.series_id} , {data.observation_start} to {data.observation_end} </span>
        </div>
    );

    const handleInputChange = newValue => {

        setInputValue(newValue);

        setIsLoading(true);
        try {
            const queryParams = new URLSearchParams({
                st:newValue
            }).toString();
            fetch("/api/series/search?"+queryParams, {
                method: 'POST', headers: {
                    'Content-Type': 'application/json',
                }, body: JSON.stringify({}),
            }).then(response => response.json()).then(result => {
                const formattedOptions = result.data.map(item => ({
                    value: item.series_id,
                    /*label: customLabelFormat(item),*/
                    label: item.title,
                    data:item
                }));
                setOptions(formattedOptions);
            })
        } catch (error) {
            console.error('Error fetching data:', error);
            setOptions([]);
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div style={{textAlign:'left'}}>
            <Select
                placeholder='选择一个数据系列'
                onInputChange={handleInputChange}
                isLoading={isLoading}
                className='add-series-select'
                onChange={handleChange}
                options={options}
            />
            <p/>
            <button type="button" className="btn btn-secondary btn-sm" onClick={() => addSeries(selectedOption.value)}>添加到数据系列</button>

        </div>
    );
}


const SeriesContent = () => {
    const {seriesId} = useParams();

    let [series, setSeries] = useState({
        "parent_list":[]
    });
    const [last_point, setLastPoint] = useState({
        "x":'2020: ',
        "y":0
    });

    const [chartOptions, setChartOptions] = useState({
        chart:{

        }
    });

    const [seriesList, setSeriesList] = useState([]);

    const chartRef = useRef(null);

    const {userinfo, isLogin} = useUser()

    const [initChart, setInitChart] = useState({});

    const addSeries = (seriesId) => {
        // 存在忽略
        const filetered = seriesList.filter((item)=>item.series_id == seriesId)
        if (filetered.length >0){
            return
        }

        const queryParams = new URLSearchParams({
            seriesId: seriesId
        }).toString();

        fetch("/api/series/info?" + queryParams, {
            method: 'GET'
        }).then(response => response.json()).then(data => {
            series = data.data
            setSeries(data.data)
            fetchSeriesData(series);
        })
    };

    const fetchSeriesData = (series) => {

        fetch("/api/series/data/" + series.series_id, {
            method: 'POST'
        }).then(response => response.json()).then(result => {
            series['data'] = result.data[0]
            const newSeriesList = [...seriesList,series];
            setSeriesList(newSeriesList)
            const newSeriesData = newSeriesList.map(item => item.data)
            const newChartOptions = {
                colors: ['#6B4A9F','#7cb5ec', '#434348', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#8085e8', '#8d4653', '#91e8e1'],
                tooltip:{
                    xDateFormat: '%Y-%m-%d',
                    pointFormatter: function() {
                        return this.series.name+': <b>' + this.y + '</b><br>';
                    }
                },
                title: {
                    text: series.title,
                    y: 12
                },
                credits:{
                    text: "数据兔",
                    href: "/series/"+series.series_id,
                    style:{
                        fontSize: "0.7em"
                    }

                }
                ,
                lang: {
                    viewData: '查看数据表',
                    hideData: '隐藏数据表'
                },exporting: {
                    buttons: {

                        contextButton: {
                            enabled: false,
                            text:"下载",
                            symbolY: 12,
                            x: 0, // 自定义X位置
                            y: 0, // 自定义Y位置
                            className: 'custom-export-btn'
                        }
                    },
                    filename: series.title,
                    menuItemDefinitions: {
                        viewFullscreen:{
                            text: '全屏'
                        },
                        printChart:{
                            text: '打印',
                            onclick: function (){
                                if (allowExport("printChart")){
                                    this.print()
                                }
                            }
                        },
                        downloadPNG: {
                            text: '下载 PNG 图片',
                            onclick: function (){
                                if (allowExport("printChart")){
                                    this.exportChartLocal()
                                }
                            }
                        },
                        downloadJPEG: {
                            text: '下载 JPEG 图片'
                            ,
                            onclick: function (){
                                if (allowExport("printChart")){
                                    this.exportChartLocal({type: "image/jpeg"})
                                }
                            }
                        },
                        downloadPDF: {
                            text: '下载 PDF 文件'
                            ,
                            onclick: function (){
                                if (allowExport("printChart")){
                                    this.exportChartLocal({type: "application/pdf"})
                                }
                            }
                        },
                        downloadSVG: {
                            text: '下载 SVG 矢量图'
                            ,
                            onclick: function (){
                                if (allowExport("printChart")){
                                    this.exportChartLocal({type: "image/svg+xml"})
                                }
                            }
                        },downloadXLS:{
                            text: '下载 XLS'
                            ,
                            onclick: function (){
                                if (allowExport("printChart")){
                                    this.downloadXLS()
                                }
                            }
                        },downloadCSV:{
                            text: '下载 CSV'
                            ,
                            onclick: function (){
                                if (allowExport("printChart")){
                                    this.downloadCSV()
                                }
                            }
                        },viewData:{
                            text: '查看数据表'
                            ,
                            onclick: function (){
                                if (allowExport("printChart")){
                                    this.toggleDataTable()
                                }
                            }
                        },hideData:{
                            text: '隐藏数据表'
                        }
                    },
                    chartOptions: {
                        chart: {
                            width: 1200 // 这里设置导出图表的宽度
                        }
                    },
                    scale: 2 // 导出图表时不进行缩放，保持原始尺寸
                },
                xAxis: {
                    //表示为时间，注意大小写
                    type: 'datetime',

                    //间距，时间戳，以下表示间距为1天，如果想表示间距为1周，就这么写
                    //7*24*3600*1000
                    //tickInterval:  24 * 3600 * 1000*365,
                    //格式化时间，day,week....
                    dateTimeLabelFormats: {
                        day: '%Y-%m'
                    },events: {
                        afterSetExtremes: function() {
                            var xAxis = this;
                            var min = xAxis.min;
                            var max = xAxis.max;
                            var lastPoint = null;
                            const chart = chartRef.current.chart;
                            chart.series.forEach(function(series) {
                                var filteredData = series.points.filter(function(point) {
                                    return point.x >= min && point.x <= max;
                                });

                                if (filteredData.length > 0) {
                                    var seriesLastPoint = filteredData[filteredData.length - 1];
                                    if (!lastPoint || seriesLastPoint.x > lastPoint.x) {
                                        lastPoint = seriesLastPoint;
                                    }
                                }
                            });
                            if (lastPoint) {
                                setLastPoint({
                                    "x":Highcharts.dateFormat('%Y:', lastPoint.x),
                                    "y":lastPoint.y
                                })
                            }
                        }
                    }
                },
                yAxis: {
                    title: {
                        text: series.units
                    }
                    ,opposite:false
                },
                rangeSelector: {
                    selected: 3, // 默认选中一段时间
                    /*inputEnabled: true,*/
                    inputDateFormat: '%Y/%m/%d', // 输入框显示的日期格式
                    inputEditDateFormat: '%Y/%m/%d', // 输入框编辑时的日期格式
                    inputDateParser: function(value) {
                        return Date.parse(value); // 解析输入框中的日期
                    },
                    inputStyle: {
                        fontSize: '14px' // 设置输入框中文字的大小
                    },
                    buttons: [{
                        type: 'year',
                        count: 1,
                        text: '1Y'
                    },{
                        type: 'year',
                        count: 5,
                        text: '5Y'
                    },{
                        type: 'year',
                        count: 10,
                        text: '10Y'
                    }, {
                        type: 'all',
                        text: 'Max'
                    }]
                },
                scrollbar: {
                    enabled: false
                }
                ,navigator: {
                    enabled: true // Enable the navigator
                },chart: {
                    type: 'line',
                    style: {
                        minHeight: '550px'
                    }
                },
                legend: {
                    enabled: true, // 显示图例
                    layout: 'horizontal', // 设置水平布局
                    align: 'left', // 居中对齐
                    verticalAlign: 'top', // 顶部对齐
                },
                series: newSeriesData

            }
            setChartOptions(newChartOptions)

            if (newSeriesList.length === 1){
                const chart = chartRef.current.chart;
                let initChart = {
                    "type":newChartOptions.chart.type,
                    "height": newChartOptions.chart.height,
                    'width': chart.chartWidth
                };
                setInitChart(initChart)
                setFormatData({
                    ...formatData,
                    chart: initChart
                });
            }
        })
    };

    const removeSeries = (event,series_id) =>{
        const newSeriesList = seriesList.filter(item=>item.series_id !=series_id)
        setSeriesList(newSeriesList)
        const newSeriesData = newSeriesList.map(item => item.data)
        setChartOptions({
            colors: ['#6B4A9F','#7cb5ec', '#434348', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#8085e8', '#8d4653', '#91e8e1'],
            tooltip:{
                xDateFormat: '%Y-%m-%d',
                pointFormatter: function() {
                    return this.series.name+': <b>' + this.y + '</b><br>';
                }
            },
            title: {
                text: series.title,
                y: 12
            },
            credits:{
                text: "数据兔",
                href: "/series/"+series.series_id,
                style:{
                    fontSize: "0.7em"
                }

            }
            ,
            lang: {
                viewData: '查看数据表',
                hideData: '隐藏数据表'
            },exporting: {
                buttons: {

                    contextButton: {
                        enabled: false,
                        text:"下载",
                        symbolY: 12,
                        x: 0, // 自定义X位置
                        y: 0, // 自定义Y位置
                        className: 'custom-export-btn'
                    }
                },
                filename: series.title,
                menuItemDefinitions: {
                    viewFullscreen:{
                        text: '全屏'
                    },
                    printChart:{
                        text: '打印',
                        onclick: function (){
                            if (allowExport("printChart")){
                                this.print()
                            }
                        }
                    },
                    downloadPNG: {
                        text: '下载 PNG 图片',
                        onclick: function (){
                            if (allowExport("printChart")){
                                this.exportChartLocal()
                            }
                        }
                    },
                    downloadJPEG: {
                        text: '下载 JPEG 图片'
                        ,
                        onclick: function (){
                            if (allowExport("printChart")){
                                this.exportChartLocal({type: "image/jpeg"})
                            }
                        }
                    },
                    downloadPDF: {
                        text: '下载 PDF 文件'
                        ,
                        onclick: function (){
                            if (allowExport("printChart")){
                                this.exportChartLocal({type: "application/pdf"})
                            }
                        }
                    },
                    downloadSVG: {
                        text: '下载 SVG 矢量图'
                        ,
                        onclick: function (){
                            if (allowExport("printChart")){
                                this.exportChartLocal({type: "image/svg+xml"})
                            }
                        }
                    },downloadXLS:{
                        text: '下载 XLS'
                        ,
                        onclick: function (){
                            if (allowExport("printChart")){
                                this.downloadXLS()
                            }
                        }
                    },downloadCSV:{
                        text: '下载 CSV'
                        ,
                        onclick: function (){
                            if (allowExport("printChart")){
                                this.downloadCSV()
                            }
                        }
                    },viewData:{
                        text: '查看数据表'
                        ,
                        onclick: function (){
                            if (allowExport("printChart")){
                                this.toggleDataTable()
                            }
                        }
                    },hideData:{
                        text: '隐藏数据表'
                    }
                },
                chartOptions: {
                    chart: {
                        width: 1200 // 这里设置导出图表的宽度
                    }
                },
                scale: 2 // 导出图表时不进行缩放，保持原始尺寸
            },
            xAxis: {
                //表示为时间，注意大小写
                type: 'datetime',

                //间距，时间戳，以下表示间距为1天，如果想表示间距为1周，就这么写
                //7*24*3600*1000
                //tickInterval:  24 * 3600 * 1000*365,
                //格式化时间，day,week....
                dateTimeLabelFormats: {
                    day: '%Y-%m'
                },events: {
                    afterSetExtremes: function() {
                        var xAxis = this;
                        var min = xAxis.min;
                        var max = xAxis.max;
                        var lastPoint = null;
                        const chart = chartRef.current.chart;
                        chart.series.forEach(function(series) {
                            var filteredData = series.points.filter(function(point) {
                                return point.x >= min && point.x <= max;
                            });

                            if (filteredData.length > 0) {
                                var seriesLastPoint = filteredData[filteredData.length - 1];
                                if (!lastPoint || seriesLastPoint.x > lastPoint.x) {
                                    lastPoint = seriesLastPoint;
                                }
                            }
                        });
                        if (lastPoint) {
                            setLastPoint({
                                "x":Highcharts.dateFormat('%Y:', lastPoint.x),
                                "y":lastPoint.y
                            })
                        }
                    }
                }
            },
            yAxis: {
                title: {
                    text: series.units
                }
                ,opposite:false
            },
            rangeSelector: {
                selected: 3, // 默认选中一段时间
                /*inputEnabled: true,*/
                inputDateFormat: '%Y/%m/%d', // 输入框显示的日期格式
                inputEditDateFormat: '%Y/%m/%d', // 输入框编辑时的日期格式
                inputDateParser: function(value) {
                    return Date.parse(value); // 解析输入框中的日期
                },
                inputStyle: {
                    fontSize: '14px' // 设置输入框中文字的大小
                },
                buttons: [{
                    type: 'year',
                    count: 1,
                    text: '1Y'
                },{
                    type: 'year',
                    count: 5,
                    text: '5Y'
                },{
                    type: 'year',
                    count: 10,
                    text: '10Y'
                }, {
                    type: 'all',
                    text: 'Max'
                }]
            },
            scrollbar: {
                enabled: false
            }
            ,navigator: {
                enabled: true // Enable the navigator
            },chart: {
                type: 'line',
                height: '550' // 设置为自动高度
            },
            legend: {
                enabled: true, // 显示图例
                layout: 'horizontal', // 设置水平布局
                align: 'left', // 居中对齐
                verticalAlign: 'top', // 顶部对齐
            },
            series: newSeriesData

        })

    }

    useEffect(() => {
        addSeries(seriesId);
    }, []);

    const allowExport = (event) => {
        let has_session = userinfo!=null;
        if (has_session){
            return true
        }else{
            document.getElementById("login_btn").click();

        }
    }
    const downloadChart = (event, text) => {
        event.preventDefault(); // 阻止默认的跳转行为
        const chart = chartRef.current.chart;
        if (text === "viewFullscreen"){
            chart.fullscreen && chart.fullscreen.toggle()
            return;
        }

        if (!allowExport("printChart")){
            return;
        }
        if (text === "printChart"){
            chart.print()
        }else if (text === "downloadPNG"){
            chart.exportChart()
        }else if (text === "downloadJPEG"){
            chart.exportChart({type: "image/jpeg"})
        }else if (text === "downloadPDF"){
            chart.exportChart({type: "application/pdf"})
        }else if (text === "downloadSVG"){
            chart.exportChart({type: "image/svg+xml"})
        }else if (text === "downloadXLS"){
            chart.downloadXLS()
        }else if (text === "downloadCSV"){
            chart.downloadCSV()
        }else if (text === "viewData"){
            chart.toggleDataTable()
        }
    };


    const [formatData, setFormatData] = useState({
        chart: {}
    });

    useEffect(() => {
        const chart = chartRef.current.chart;

        if (chart) {
            chart.reflow(); // 手动触发重新布局和绘制
        }
    }, [chartOptions]);

    const formatHandleChange = (e) => {
        const { name, value } = e.target;
        setFormatData({
            ...formatData,
            chart: {
                ...formatData.chart,
                [name]: value
            }
        });
    };

    const applyChartOptions = () =>{
        const newOptions = {
            ...chartOptions,
            chart: {
                ...chartOptions.chart,
                type: formatData.chart.type,
                width: formatData.chart.width,
                style: {
                    minHeight: formatData.chart.height // 设置最小高度
                }
            }
        };

        setChartOptions(newOptions)
    }

    const resetChartOptions = () =>{
        setFormatData({
            ...formatData,
            chart: initChart
        });

        setChartOptions({
            ...chartOptions,
            chart: initChart
        })
    }

    return (
        <div className="col-12 container-fluid" id="main-content-column">
            <nav id="breadcrumbs" className="site-breadcrumbs" aria-label="site breadcrumbs">
                <a className="breadcrumb_link" href="/categories">类别</a>
                {
                    series.parent_list.map((item, index) => (
                        <span> &gt; <a className="breadcrumb_link" href={'/categories/' + item.id}>{item.name}</a></span>
                    ))
                }

            </nav>
            <div id="page-title" className="page-title">
                <div className="series-title">
            <span id="series-title-text-container" className="col-10 col-lg-11 float-start">
              <div id="favorite-toggle-container" className="favorite-toggle-container">
                <a href="#" tabIndex={0} id="favorite-star" style={{marginLeft:'10px'}} className="far fa4 fa-star series-focus favorite-toggle" data-series-id="A006RE1A156NBEA" title="Add to Favorites"/>
              </div>  <h1 style={{display: 'inline'}}>
                <span>{series.title}</span>
                <span className="smaller"> ({series.series_id})</span>
              </h1>
            </span>
                    <div id="download-button-container">
                    </div>
                </div>
                <input type="hidden" name="series-recently-viewed" className="series-recently-viewed" defaultValue="Shares of gross domestic product: Gross private domestic investment"/>
            </div>
            <div id="series-meta-row" className="row series-attributes">
                <div id="meta-left-col" className="col-12 col-sm-12 col-md-6 row">
                    <div id="mobile-meta-col" style={{display: 'none'}} className="float-start gx-0">
                        <span className="last_point_x">{last_point.x}</span>
                        <span className="series-meta-observation-value last_point_y">{last_point.y}</span> |
                        <span>{series.units}</span> |
                        <span className="series-meta-value-frequency">{series.seasonal_adjustment}</span> |
                        Updated:
                        <span title={series.last_updated}>
                                    <span className="series-meta-updated-date">{series.last_updated}</span>
                                </span>
                    </div>
                    <div className="float-start meta-col col-sm-5 col-5" style={{paddingLeft: 0}}>
                        <p className="series-meta-label">观测时间:</p>
                        <span className="series-meta-value last_point_x">{last_point.x}</span>
                        <span className="series-meta-observation-value last_point_y">{last_point.y}</span>
                        <span className="recent-obs-link-container">
                <span className="small d-none d-md-flex link recent-obs-link series-focus fg-mega-edit-gtm fg-more-obs-gtm" tabIndex={0} data-toggle="popover">&nbsp;
                </span>
              </span>
                        <span className="updated-text" title={series.last_updated}>
                更新时间:
                            <span className="series-meta-updated-date">{series.last_updated}</span>
              </span>
                        <div className="d-none d-md-flex hide">
                            <div id="recent-obs-table">
                            </div>
                        </div>
                    </div>
                    <div className="float-start meta-col col-sm-4 col-4">
                        <p className="series-meta-label">单位:</p>
                        <span className="series-meta-value">
                            <span className="series-meta-value-units">{series.units}</span>
              </span>
                    </div>
                    <div className="float-start meta-col col-sm-3 col-3">
                        <p className="series-meta-label">频率:</p>
                        <span className="series-meta-value">
                            <span className="series-meta-value-frequency">{series.frequency}</span>
              </span>
                    </div>
                </div>
                <div id="meta-right-col" className="col-12 col-sm-12 col-md-6 row">
                    <div style={{float: 'right', textAlign: 'right'}}>
                        <button className="btn btn-secondary dropdown-toggle" style={{marginRight: '20px'}} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            下载或导出
                        </button>
                        <ul className="dropdown-menu">
                            <li><a className="dropdown-item" href="#/" onClick={(event) => downloadChart(event, 'printChart')}>打印</a></li>
                            <li>
                                <hr className="dropdown-divider"/>
                            </li>
                            <li><a className="dropdown-item" href="#/" onClick={(event) => downloadChart(event, 'downloadPNG')}>下载 PNG</a></li>
                            <li><a className="dropdown-item" href="#/" onClick={(event) => downloadChart(event, 'downloadJPEG')}>下载 JPEG</a></li>
                            <li><a className="dropdown-item" href="#/" onClick={(event) => downloadChart(event, 'downloadPDF')}>下载 PDF</a></li>
                            <li><a className="dropdown-item" href="#/" onClick={(event) => downloadChart(event, 'downloadSVG')}>下载 SVG</a></li>
                            <li>
                                <hr className="dropdown-divider"/>
                            </li>
                            <li><a className="dropdown-item" href="#/" onClick={(event) => downloadChart(event, 'downloadXLS')}>下载 XLS</a></li>
                            <li><a className="dropdown-item" href="#/" onClick={(event) => downloadChart(event, 'downloadCSV')}>下载 CSV</a></li>
                            <li><a className="dropdown-item" href="#/" onClick={(event) => downloadChart(event, 'viewData')}>查看数据表</a></li>
                        </ul>
                        <button type="button" className="btn btn-secondary" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">编辑图表</button>
                        <div className="offcanvas offcanvas-end" style={{width:'450px'}} tabIndex={-1} id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                            <div className="offcanvas-header">
                                <h5 className="offcanvas-title" id="offcanvasRightLabel">编辑图表</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"/>
                            </div>
                            <div className="offcanvas-body">
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                    <li className="nav-item dropdown">
                                        <div className='series-count'>{seriesList.length}</div>
                                        <a className="nav-link active dropdown-toggle" style={{position: 'relative', top: 1}} data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">编辑系列</a>

                                        <ul className="dropdown-menu" style={{width: '368px'}}>
                                            {
                                                seriesList.map((item, index) => (
                                                    <li><a className={`dropdown-item ${index == 0 ? 'active' : ''}`} data-bs-toggle="tab" data-bs-target={'#line-tab-pane-' + index} type="button" role="tab" aria-controls={'line-tab-pane-' + 1} aria-selected="false" href="#">{item.title}</a></li>
                                                ))
                                            }
                                        </ul>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">添加系列</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact-tab-pane" type="button" role="tab" aria-controls="contact-tab-pane" aria-selected="false">格式化</button>
                                    </li>
                                </ul>
                                <div className="tab-content" id="myTabContent">
                                    {
                                        seriesList.map((item, index) => (
                                            <div style={{textAlign:'left'}} className={`tab-pane fade show ${index==0?'active':''}`} id={'line-tab-pane-' + index} role="tabpanel" aria-labelledby="home-tab" tabIndex={0}>
                                                <div className="series-title-background mb-0" >
                                                    <div className="series-title-text"><span className="title-series-variable text-muted">(a)</span><span>&nbsp;{item.title}</span>,<span
                                                        className="series-title-attribs">&nbsp;{item.units},&nbsp;{item.frequency}&nbsp;</span><span className="text-muted smaller-80">&nbsp;({item.series_id})</span></div>

                                                    <div className="title-series-remove">
                                                        {
                                                            seriesList.length > 1 ? (
                                                                <i className="far fa-trash-alt remove-series remove-series-4-a float-end fg-mega-edit-gtm" role="button" tabIndex={0} onClick={(event) => removeSeries(event, item.series_id)} data-target-option="remove-series" data-series-variable="a"/>
                                                            ):('')
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }

                                    <div className="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabIndex={0}>

                                        <MySelectComponent addSeries={addSeries}/>
                                    </div>
                                    <div className="tab-pane fade" id="contact-tab-pane" role="tabpanel" aria-labelledby="contact-tab" tabIndex={0}>
                                        <div className="container item-panel chart-option-values" >
                                            <div className="row">
                                                <div className="col">
                                                    <label htmlFor="inputPassword6" className="col-form-label">图表类型:</label>
                                                    <select name={'type'} value={formatData.chart.type}  onChange={formatHandleChange} className="form-select">
                                                        <option value="line">线条</option>
                                                        <option value="column">柱状图</option>
                                                        <option value="bar">条形图</option>
                                                        <option value="pie">饼图</option>
                                                        <option value="scatter">散点图</option>
                                                        <option value="area">面积图</option>
                                                    </select>
                                                </div>
                                                <div className="col">
                                                    <label  className="col-form-label">宽:</label>
                                                    <input type="text" name={'width'} value={formatData.chart.width}  onChange={formatHandleChange} className="form-control"/>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">

                                                </div>
                                                <div className="col">
                                                    <label htmlFor="inputPassword6" className="col-form-label">高:</label>
                                                    <input type="text" name={'height'} value={formatData.chart.height} onChange={formatHandleChange}  className="form-control" />
                                                </div>
                                                <div style={{clear:"both",marginTop:"15px"}}>
                                                    <button type="button" style={{marginRight: '10px'}} onClick={applyChartOptions} className="btn series-button fg-mega-edit-gtm" data-target-option="graph-size">应用</button>
                                                    <button type="button" className="btn series-button fg-mega-edit-gtm" onClick={resetChartOptions} data-target-option="graph-size">重置</button>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="desktop-view-chart-button-container" className="float-end">
            </div>
            <link rel="stylesheet" type="text/css" href="/static/graph/css/1717421276.fredgraph.min.css"/>
            <input type="hidden" id="cosd" defaultValue="1929-01-01"/>
            <input type="hidden" id="coed" defaultValue="2023-01-01"/>
            <input type="hidden" id="range" defaultValue/>
            <input type="hidden" id="mode" defaultValue="fred"/>
            <div>
                <div id="zoom-and-share">
                    <div id="fullscreen-container">
                        <div id="resizable-graph-container">
                            <div id="root" data-graph-mode="datarabbit" style={{ width: chartOptions.chart.width+'px', height: chartOptions.chart.height+'px' }}>
                                <HighchartsReact highcharts={Highcharts} constructorType={'stockChart'} ref={chartRef} options={chartOptions}/>
                            </div>
                        </div>
                        <br style={{clear: 'both'}}/>
                        <div id="fullscreen-btn" tabIndex={0} aria-label="Full screen">
                            <img src="/static/graph/images/fullscreen.png" onClick={(event) => downloadChart(event, 'viewFullscreen')} id="fullscreen-btn-icon" style={{position: 'relative', top: 6}}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tabs-left tabs-scroll">
                <div className="tab-content-scroll noscrollbar" data-target="#tab-nav">
                    <div id="notes" className="tab-pane ">
                        <div className="panel notes-series-group">
                            <h2 className="fred-series-page-unset-style panel-heading">
                                备注
                            </h2>
                            <div id="notes-content" className="panel-body">
                                <p className="col-12 float-start mb-2"><strong>单位:</strong>&nbsp;
                                    <span className="series-meta-value">
                                        <span className="series-meta-value-units">{series.units}</span>
                  </span>
                                </p>
                                <p className="col-12 float-start mb-2"><strong>频率:</strong>&nbsp;
                                    <span className="series-meta-value">
                    <span className="series-meta-value-frequency" >{series.frequency}</span>
                  </span>
                                </p>
                                <h4 className="section-title hide">数据说明:</h4>
                                <p className="series-notes mb-2" dangerouslySetInnerHTML={{ __html: series.notes }}  ></p>
                            </div>
                        </div>
                        {/* panel */}
                    </div>
                </div>
            </div>
        </div>
    )
}


const Series = () => {


    return (<div id='container' className='container'>
        <link rel="stylesheet" href='/static/css/1717421276.series.min.css'/>
        <Helmet>
            <title>数据兔</title>
        </Helmet>
        <NonHomeHeader/>
        <div className='row clear series-page-css' id='content-container '>
            <SeriesContent/>

        </div>
        <Footer/>
    </div>);
};

export default Series
